import { useSelectors } from '@exodus/headless-react';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import useFiatMode from '../../hooks/use-fiat-mode.js';
import useFromAmount from '../../hooks/use-from-amount.js';
import useFromAsset from '../../hooks/use-from-asset.js';
import useFromFiatAmount from '../../hooks/use-from-fiat-amount.js';
import { formatAssetAmount } from '@exodus/formatting/lib/asset';
import { formatPrice } from '@exodus/formatting/lib/price';
import { useDebounceValue } from '@exodus/react-hooks';
const FromAssetValue = ({ Component, className, style, onPress, }) => {
    const selectors = useSelectors();
    const [fromAsset] = useFromAsset();
    const [fromAmount] = useFromAmount();
    const [fromFiatAmount] = useFromFiatAmount();
    const [fiatMode, setFiatMode] = useFiatMode();
    const currency = useSelector(selectors.locale.currency);
    const handleToggle = useCallback(() => {
        setFiatMode((value) => !value);
        onPress?.();
    }, [onPress, setFiatMode]);
    const formattedValue = fiatMode
        ? `${formatAssetAmount(fromAmount)} ${fromAsset.displayTicker}`
        : formatPrice(fromFiatAmount.toDefaultNumber(), { currency });
    const amount = fiatMode ? fromAmount : fromFiatAmount;
    const debouncedAmount = useDebounceValue(amount, 200);
    const debouncedFormattedValue = useDebounceValue(formattedValue, 200);
    if (Component) {
        return (React.createElement(Component, { amount: debouncedAmount, formattedValue: debouncedFormattedValue, loading: false, className: className, style: style, onPress: handleToggle, fiatMode: fiatMode, asset: fromAsset }));
    }
    return null;
};
export default FromAssetValue;
